<template>
    <div class="custom-loader">
        <v-icon>mdi mdi-48px mdi-spin mdi-loading</v-icon>
    </div>
</template>

<script>
export default {
    name: "CustomLoader"
}
</script>

<style scoped lang="scss">
.custom-loader {
    display: flex;
    justify-content: center;
}
</style>